import {
  SealedBucketTrailerModalExperiment,
  getTrailerFromContent,
} from 'experiments/pen-4743-qr-sealed-bucket'
import { useCourseOrSessionBySlug } from 'libs/client/api'
import { useQRCTAHref } from 'pages/find-my-classes/hooks'
import VideoModal from 'components/VideoModal'

import { useVideoContext } from './useVideoContext'

export const TrailerModal = () => {
  const { isModalOpen, currentContent, closeVideo } = useVideoContext()
  const { contentBySlug: content } = useCourseOrSessionBySlug(
    currentContent?.slug,
    currentContent?.type,
  )

  // useQRCTAHref() will return undefined if the user is not on the quiz results page
  // and trailer modal will redirect to the value of the usePrimaryCta hook
  const ctaHref = useQRCTAHref()

  if (!content) {
    return null
  }

  const trailerData = getTrailerFromContent(content)

  return (
    !!content && (
      <SealedBucketTrailerModalExperiment
        control={
          <VideoModal
            show={isModalOpen}
            onCloseModal={closeVideo}
            mediaUuid={trailerData?.mediaId}
            trackProps={{ uuid: trailerData.uuid }}
            author={trailerData.instructorName}
            tagline={trailerData.skill}
            contentId={`${trailerData.id}_${trailerData.mediaId}`}
            contentTitle={trailerData.title}
            contentType={trailerData.contentType}
            courseId={trailerData.id}
            instructorAvatar={trailerData.instructorAvatarUrl}
            signUpHref={ctaHref}
          />
        }
        onClose={closeVideo}
        course={content}
      />
    )
  )
}
